/*
 * AdminGroupDetails Messages
 *
 * This contains all the text for the AdminGroupDetails component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  groups: {
    id: 'app.components.AdminGroups.groups',
    defaultMessage: 'Groups',
  },
  settings: {
    id: 'app.common.settings',
    defaultMessage: 'Settings',
  },
  saveSuccess: {
    id: 'app.common.saveSuccess',
    defaultMessage: 'The changes are saved',
  },
  members: {
    id: 'app.common.members',
    defaultMessage: 'Members',
  },
  general: {
    id: 'app.components.AdminGroupDetails.general',
    defaultMessage: 'General',
  },
  about: {
    id: 'app.components.AdminGroupDetails.about',
    defaultMessage: 'About \'{name}\'',
  },
  edit: {
    id: 'app.components.AdminGroupDetails.edit',
    defaultMessage: 'Edit {groupType, select, 2 {Class} other {Group}} \'{name}\'',
  },
  logo: {
    id: 'app.components.AdminGroupDetails.logo',
    defaultMessage: 'Logo',
  },
  groupColor: {
    id: 'app.components.AdminGroupDetails.groupColor',
    defaultMessage: 'Group Color',
  },
  tagLine: {
    id: 'app.components.AdminGroupDetails.tagLine',
    defaultMessage: 'Tagline',
  },
  name: {
    id: 'app.common.name',
    defaultMessage: 'Naam',
  },
  groupSettings: {
    id: 'app.components.AdminGroupDetails.groupSettings',
    defaultMessage: 'Group Settings',
  },
  appendParents: {
    id: 'app.components.AdminGroupDetails.appendParents',
    defaultMessage: 'Add Parents Automatically',
  },
  appendParentsHelp: {
    id: 'app.components.AdminGroupDetails.appendParentsHelp',
    defaultMessage: 'When a student is added, the parents are automatically added as well.',
  },
  showContacts: {
    id: 'app.components.AdminGroupDetails.showContacts',
    defaultMessage: 'Show List of Members',
  },
  showContactsHelp: {
    id: 'app.components.AdminGroupDetails.showContactsHelp',
    defaultMessage: 'Parents can see each others contact details if these are shared in their profile',
  },
  appsPermissions: {
    id: 'app.components.AdminGroupDetails.appsPermissions',
    defaultMessage: 'Apps and Permissions',
  },
  groupOwners: {
    id: 'app.components.AdminGroupDetails.groupOwners',
    defaultMessage: 'Group Owners',
  },
  groupOwnersHelp: {
    id: 'app.components.AdminGroupDetails.groupOwnersHelp',
    defaultMessage: 'Group owners can change group settings and manage members of the group. They will also receive notifications of absence reports if this option is set by the school.',
  },
  addOwner: {
    id: 'app.components.AdminGroupDetails.addOwner',
    defaultMessage: 'Add Owner',
  },
  confirmRemoveOwner: {
    id: 'app.components.AdminGroupDetails.confirmRemoveOwner',
    defaultMessage: 'Remove "{displayName}" as owner?',
  },
  ownersUpdated: {
    id: 'app.components.AdminGroupDetails.ownersUpdated',
    defaultMessage: 'The list of owners has been updated',
  },
  archiveGroup: {
    id: 'app.components.AdminGroups.archiveGroup',
    defaultMessage: 'Archive Group',
  },
  confirmArchive: {
    id: 'app.components.AdminGroups.confirmArchive',
    defaultMessage: 'Archive group \'\'{name}\'\'?',
  },
  doArchive: {
    id: 'app.components.AdminGroups.doArchive',
    defaultMessage: 'Archive',
  },
  close: {
    id: 'app.common.close',
    defaultMessage: 'Close',
  },
  portfolio: {
    id: 'app.components.AdminGroups.portfolio',
    defaultMessage: 'Portfolio',
  },
  portfolioIntro: {
    id: 'app.components.AdminGroups.portfolioIntro',
    defaultMessage: 'The portfolio is enabled for your class. Decide if you want it to be visible to parents and students as well.',
  },
  visibilityLabel: {
    id: 'app.components.GroupSettings.visibilityLabel',
    defaultMessage: 'Visible to parents and students',
  },
});
